<script>
  import { getContext, onMount, createEventDispatcher } from 'svelte';
  import { TabulatorFull as Tabulator } from 'tabulator-tables/dist/js/tabulator_esm';
  import 'tabulator-tables/dist/css/tabulator.min.css';
  import { SelectRowModule } from 'tabulator-tables';

  import { navigate } from 'svelte-navigator';
  // import { url as urlPath } from "Core/Components/Url";

  export let tableObj;
  export let tableId = 'table-tabulator';
  export let selectable = false;
  export let selectableAll = false;
  export let dataTree = false;
  export let pagination = true;
  export let tableData;
  export let columns = [];
  export let expanded = false;
  export let Style;
  export let addPageSizeOptions = [];
  export let paginationSize = 100;
  export let movableColumns = false;
  export let rowClickable = false;
  export let selectableRow = false;
  export let multiSelect = false;
  export let infiniteScroll = false;
  export let autoColumns = false;
  export let selectedRowId = 0;
  export let selectedRowIds = [];
  const showDialog = getContext('showDialog');
  export let loadData = (size, page, sorting) => {};
  export let cellEdited = (cell) => {};
  export let loadComplete = () => {};
  export let rowFormatter = () => {};
  export let onColumnMoved = (column, columns) => {};
  export let rowClickCallaback = (e, cell) => {};
  export let expandCollepseCallaback = (e, cell) => {};
  export let rowSelectCallback = (cell, row) => {};
  export let rowDeSelectCallback = (e, cell) => {};

  let totalCount = 0;
  let filterParams = {};
  let dispatch = createEventDispatcher();

  const fetchAjaxData = (url, config, params) => {
    return new Promise(function (resolve, reject) {
      let searchParams = {
        ...extraParams,
      };

      if (params.sort.length > 0) {
        ((searchParams.sort_by = params.sort[0].field),
          (searchParams.sort_order = params.sort[0].dir));
      }

      filterParams = {
        ...searchParams,
        page_size: params.size == true ? '-1' : params.size,
        page: params.page,
      };

      loadData(params.size == true ? '-1' : params.size, params.page, searchParams)
        .then((data) => {
          let records = data;
          dispatch('tableLoaded', records.meta.total);
          if (pagination == false) {
            data.data = setDriverData(data.data, false);
          }

          resolve(
            pagination
              ? {
                  last_page: data.meta.last_page,
                  data: data.data,
                }
              : data.data,
          );
          setTimeout(() => {
            loadComplete();
          }, 500);
        })
        .catch((err) => {
          ///tableObj.clearData();

          if (err.message.startsWith('invalid_access')) {
            // navigate(urlPath.invalidAccess, { replace: true });
            showDialog('invalid_access');
          } else {
            reject(err);
            showDialog(err);
          }
        });
    });
  };
  const setDriverData = (data, flag) => {
    return data.map((item, key) => {
      item.driver = flag;
      if (item._children) {
        item._children.map((childitem) => {
          childitem.driver = flag;
          return childitem;
        });
      }
      return item;
    });
  };
  let loadTimeout = '';
  let loadDelay = 250;
  export const reloadData = (flag) => {
    if (tableObj) {
      loadTimeout != '' && clearTimeout(loadTimeout);
      loadTimeout = setTimeout(() => {
        if (flag != undefined) {
          tableObj.setPage(tableObj.getPage());
        } else {
          tableObj.setData();
        }
      }, loadDelay);
    }
  };
  export let extraParams = {};
  $: extraParams && reloadData();
  if (selectable) {
    columns = [
      {
        width: 45,
        formatter: 'rowSelection',
        cssClass: 'custom-checkbox-cell',
        titleFormatter: 'rowSelection',
        hozAlign: 'center',
        vertAlign: 'middle',
        columnVertAlign: 'center',
        headerSort: false,
        cellClick: function (e, cell) {
          cell.getRow().toggleSelect();
        },
      },
      ...columns,
    ];
  }
  onMount(() => {
    let config = {
      columnDefaults: {
        selectable: selectable || rowClickable,
      },

      // selectable: selectable,
      persistence: {
        page: {
          size: true,
          page: false,
        },
      },
      dataTree: dataTree,
      dataTreeStartExpanded: function (row, level) {
        return row.getData().driver ? row.getData().driver : expanded;
      },
      rowFormatter: function (row) {
        rowFormatter && rowFormatter(row);
      },
      persistenceMode: 'cookie',
      layout: 'fitColumns',
      height: '100%',
      columnHeaderSortMulti: false,
      ajaxURL: '#',
      paginationSize: paginationSize,
      placeholder: 'No Record Found',
      columns: columns,
      filterMode: 'remote',
    };
    if (selectableRow) {
      config = {
        ...config,
        selectable: multiSelect ? true : 1,
        selectablePersistence: false,
      };
    }
    if (infiniteScroll) {
      config = {
        ...config,

        progressiveLoadDelay: 0,
        progressiveLoadScrollMargin: 200,
        progressiveLoad: 'scroll',
      };
    } else {
      config = {
        ...config,
        pagination: pagination,
        paginationSizeSelector: [10, 25, 50, 100, 250, 500, ...addPageSizeOptions],
        paginationInitialPage: 1,
      };
    }
    if (tableData) {
      config = {
        ...config,
        data: tableData,
        autoColumns: autoColumns,
      };
    } else {
      config = {
        ...config,
        ajaxRequestFunc: fetchAjaxData,
        sortMode: 'remote',
        paginationMode: 'remote',
        movableColumns: movableColumns,
      };
    }

    tableObj = new Tabulator('#' + tableId, config);
    tableObj.on('cellEdited', function (cell) {
      cellEdited(cell);
    });
    tableObj.on('rowClick', function (e, row) {
      if (e.target.classList.length > 0 && e.target.classList.contains('tabulator-cell')) {
        var children = row.getTreeChildren();
        if (children.length > 0) {
          row.treeToggle();
        }
      }
      return false;
    });
    if (selectableRow) {
      tableObj.on('renderComplete', function () {
        if (selectedRowId) {
          tableObj.selectRow(selectedRowId);
        }
        if (selectedRowIds.length > 0) {
          tableObj.selectRow(selectedRowIds);
        }
        // tableObj.selectRow(tableObj.getRowFromPosition(0));
      });
    }
    if (selectableAll) {
      tableObj.on('renderComplete', function () {
        tableObj.selectRow();
      });
    }
    tableObj.on('dataTreeRowExpanded', function (row, level) {
      let data = row.getData();
      data.driver = true;
      row.update(data);
      expandCollepseCallaback('expand', data);
    });
    tableObj.on('dataTreeRowCollapsed', function (row, level) {
      let data = row.getData();
      data.driver = false;
      row.update(data);
      expandCollepseCallaback('collapse', data);
    });

    if (movableColumns) {
      tableObj.on('columnMoved', function (column, columns) {
        onColumnMoved(column, columns);
      });
    }
    if (selectableRow) {
      tableObj.on('rowSelected', function (row) {
        //row - row component for the selected row
        rowSelectCallback(tableObj.getSelectedData(), tableObj.getSelectedRows());
      });

      tableObj.on('rowDeselected', function (row) {
        //row - row component for the deselected row
        rowDeSelectCallback(tableObj.getSelectedData());
      });
    }
    if (rowClickable) {
      tableObj.on('rowClick', function (e, row) {
        rowClickCallaback(e, row.getData());
      });
    }
  });

  export const getColumns = (title) => {
    return tableObj.getColumn(title);
  };

  export const getSelectedData = () => {
    return tableObj.getSelectedData();
  };
  export const getSelectedId = () => {
    return tableObj.getSelectedData().map((item) => {
      return { id: item.id };
    });
  };

  export const getExpendStatus = () => {
    return expanded;
  };

  export const toggleRow = () => {
    expanded = !expanded;
    tableObj.replaceData(setDriverData(tableObj.getData(), expanded));
  };
  export const redraw = () => {
    tableObj.redraw(true);
  };
  export const setData = (data) => {
    tableObj.setData(data);
  };
  export const setColumns = (column) => {
    tableObj.setColumns(column);
  };
  export const refreshData = (data) => {
    setTimeout(() => {
      tableObj.replaceData(tableObj.getData());
    }, 100);
  };

  export const getData = () => {
    return tableObj.getData();
  };

  export const getFilterParams = () => {
    return filterParams;
  };
  export const redrawCell = () => {
    tableObj.redraw();
  };
</script>

<div
  class="h-100 w-100"
  id={tableId}
></div>

<style lang="scss">
  :global(.tabulator) {
    border: 0 !important;
    background-color: transparent !important;
  }
  :global(.tabulator-col-title) {
    font-weight: 600;
    font-size: 12px;
  }
  :global(.tabulator .tabulator-header .tabulator-col) {
    background: transparent !important;
  }
  :global(.tabulator .tabulator-header) {
    background-color: transparent !important;
  }
  :global(.tabulator .tabulator-header) {
    border: 0px;
  }
  :global(.tabulator-row .tabulator-cell, .tabulator .tabulator-header .tabulator-col) {
    border: 0px;
  }
  /* :global(.tabulator-row.tabulator-row-even) {
	border-top: 1px solid #eff2f5 !important;
	border-bottom: 1px solid #eff2f5 !important;
	background-color: #f5f8fa;
  } */
  :global(.tabulator-row.tabulator-selectable:hover) {
    background-color: rgba(0, 158, 247, 0.1);
  }
  :global(.tabulator-cell) {
    font-size: 12px;
  }
  :global(.tabulator .tabulator-footer) {
    background: transparent !important;
    border: 0px;
  }
  :global(.tabulator .tabulator-loader .tabulator-loader-msg.tabulator-loading) {
    background-color: var(--clr-blue);
    border: 0px;
    font-size: 12px !important;
    color: var(--clr-white);
    font-weight: 300 !important;
  }
  :global(.tabulator-paginator label) {
    font-weight: 600;
    font-size: 12px;
  }
  :global(.tabulator .tabulator-footer .tabulator-page-size) {
    border: 1px solid var(--clr-border);
    font-size: 12px;
  }
  :global(.tabulator .tabulator-footer .tabulator-page) {
    font-size: 12px;
  }
  :global(.tabulator .tabulator-footer .tabulator-page) {
    font-size: 12px;
  }
  :global(.tabulator .tabulator-footer .tabulator-page) {
    border: 0px !important;
    padding-left: 8px;
    padding-right: 8px;
  }
  :global(.tabulator .tabulator-footer .tabulator-page.active) {
    background-color: var(--clr-blue);
    color: var(--clr-white);
  }
  :global(.tabulator .tabulator-footer .tabulator-page:not(.disabled):hover) {
    background-color: var(--clr-blue);
    color: var(--clr-white);
  }
  :global(.tabulator .tabulator-loader) {
    background: rgba(0, 0, 0, 0) !important;
  }
  :global(.tabulator-placeholder-contents) {
    font-size: 16px !important;
    font-weight: 400 !important;
    color: #6c757d !important;
  }
  :global(.data-table .tabulator .tabulator-footer .tabulator-calcs-holder .tabulator-row) {
    background-color: #fff !important;
  }
  :global(.data-table .tabulator .tabulator-footer .tabulator-calcs-holder) {
    border-bottom: 0px !important;
  }
  :global(.data-table .tabulator .tabulator-footer .tabulator-calcs-holder) {
    border-top: 0px solid var(--clr-border) !important;
  }
</style>
